/**
 * Login
 *
 * Entry screen that initiates Microsoft login via MSAL redirect. Shows a simplified
 * form-only mode (currently toggled off) and renders a snackbar alert on failures.
 */
import React, { useMemo, useState } from "react";
import "./login.scss";
import microsoftIcon from "../../assets/image/microsoft.png";
import { AlertComponent } from "../../common/components";
import LoginForm from "./login-form";
import { useSetLoading } from "../../common/hooks/appearance";
import { useMsal } from "@azure/msal-react";
interface LoginProps {
  isLoggedIn?: boolean;
}

const Login: React.FC<LoginProps> = () => {
  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLoading] = useState(false);
  const [alert, setAlert] = useState<{
    isOpen?: boolean;
    message?: any;
    type?: string;
  }>({});

  const { instance } = useMsal();

  const handleMSOLogin = () => {
    instance
      .loginRedirect({
        scopes: ["User.Read"],
        prompt: "select_account",
      })
      .then(() => {})
      .catch(() => {
        setAlert({
          isOpen: true,
          message: "Login failed. Please try again.",
          type: "error",
        });
      });
  };

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="login-page">
        {isShowLoginForm ? (
          <div className="login-page-wrapper-content-form">
            <LoginForm setIsShowLoginForm={setIsShowLoginForm} />
          </div>
        ) : (
          <div className="login-page-wrapper">
            <div className="login-page-wrapper-content">
              <div className="login-page-wrapper-content-header-main">
                Welcome to the <br />
                Leadership Enterprise Dashboard
              </div>
              <div className="login-page-wrapper-content-header-sub">
                Please sign-in to your account
              </div>
              <button
                className="login-page-wrapper-content-micro-login-button"
                onClick={handleMSOLogin}
              >
                <div className="login-page-wrapper-content-micro-login-button-img">
                  <img src={microsoftIcon} alt="Micro Login Button" />
                </div>
                <div className="login-page-wrapper-content-micro-login-button-text">
                  Log In with Microsoft
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="login-page-wrapper-content-footer">
        <div className="login-page-wrapper-content-footer-text">
          © 2025 LucyRx. All Rights Reserved.
        </div>
      </div>
      {alert?.isOpen && (
        <AlertComponent
          message={alert?.message || ""}
          type={"error"}
          open={alert?.isOpen}
          onClose={() => setAlert({})}
        />
      )}
    </>
  );
};

export default Login;
